<template xmlns="http://www.w3.org/1999/html">
  <el-dialog
    title="打印预览"
    :visible="visible"
    width="900px"
    :before-close="hideDialog"
    :close-on-click-modal="false"
  >
    <div id="ApproveAndSignPrint">
      <el-button
        type="primary"
        icon="el-icon-plus"
        @click="PrintContract"
        style="margin: 0px 20px 25px"
        >打印
      </el-button>
      <div
        ref="MeetingOrderPrint"
        id="MeetingOrderPrint"
        style="font-size: 16px"
      >
        <div style="text-align: center; font-size: 30px; padding: 30px 0 20px">
          青岛路桥建设集团有限公司会议议题提报单
        </div>
        <div style="text-align: center; font-size: 20px"></div>

        <div style="border: 1px solid rgb(0, 0, 0, 0.6); margin: 20px 0">
          <div
            style="
              border-bottom: 1px solid rgb(0, 0, 0, 0.6);
              display: flex;
              min-height: 56px;
            "
          >
            <div
              style="
                width: 120px;
                border-right: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              提报部门
            </div>
            <div
              contenteditable="true"
              style="flex: 1; padding: 4px; display: flex; align-items: center"
            >
              {{ formData.operatorDeptName }}
            </div>
            <div
              style="
                width: 120px;
                border-right: 1px solid rgb(0, 0, 0, 0.6);
                border-left: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              会议时间
            </div>
            <div
              contenteditable="true"
              style="flex: 1; padding: 4px; display: flex; align-items: center"
            >
              {{ formData.conferenceTime }}
            </div>
          </div>
          <div
            style="
              border-bottom: 1px solid rgb(0, 0, 0, 0.6);
              display: flex;
              min-height: 56px;
            "
          >
            <div
              style="
                width: 120px;
                border-right: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              会议类别
            </div>
            <div
              contenteditable="true"
              style="
                flex: 1;
                padding: 4px;
                display: flex;
                align-items: center;
                padding-left: 20px;
              "
            >
              <div v-if="formData.conferenceType == '党委会'">
                <input
                  type="CheckBox"
                  name="hobby"
                  value="党委会"
                  checked
                />党委会
              </div>
              <div v-else>
                <input type="CheckBox" name="hobby" value="党委会" />党委会
              </div>
              <div v-if="formData.conferenceType == '董事会'">
                <input
                  type="CheckBox"
                  name="hobby"
                  value="董事会"
                  checked
                />董事会
              </div>
              <div v-else>
                <input type="CheckBox" name="hobby" value="董事会" />董事会
              </div>

              <div v-if="formData.conferenceType == '总经理办公室'">
                <input
                  type="CheckBox"
                  name="hobby"
                  value="总经理办公室"
                  checked
                />总经理办公室
              </div>
              <div v-else>
                <input
                  type="CheckBox"
                  name="hobby"
                  value="总经理办公室"
                />总经理办公室
              </div>
            </div>
          </div>
          <div
            style="
              border-bottom: 1px solid rgb(0, 0, 0, 0.6);
              display: flex;
              min-height: 56px;
            "
          >
            <div
              style="
                width: 120px;
                border-right: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              会议议题
            </div>
            <div
              contenteditable="true"
              style="flex: 1; padding: 4px; display: flex; align-items: center"
            >
              {{ formData.title }}
            </div>
          </div>
          <div
            style="
              border-bottom: 1px solid rgb(0, 0, 0, 0.6);
              display: flex;
              min-height: 300px;
            "
          >
            <div
              style="
                width: 120px;
                border-right: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
              "
            >
              主要内容
              <div>(300字)</div>
            </div>
            <div
              contenteditable="true"
              style="flex: 1; padding: 4px; line-height: 20px"
            >
              {{ formData.content }}
            </div>
          </div>
          <div
            style="
              border-bottom: 1px solid rgb(0, 0, 0, 0.6);
              display: flex;
              min-height: 80px;
              page-break-inside:avoid;
            "
          >
            <div
              style="
                width: 120px;
                border-right: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              参会部门
            </div>
            <div
              contenteditable="true"
              style="
                flex: 1;
                padding: 20px;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
              "
            >
              <!-- <span
                v-for="(item, index) in formData.unLeaders"
                :key="index"
                style="margin-right: 16px"
              >
                {{ item.deptKeyName }}</span
              > -->
              {{ formData.deptNames }}
            </div>
          </div>

          <div
            style="
              border-bottom: 1px solid rgb(0, 0, 0, 0.6);
              display: flex;
              min-height: 80px;
              page-break-inside:avoid;
            "
          >
            <div
              style="
                width: 120px;
                border-right: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                text-align: center;
              "
            >
              参会部门
              <div>负责人意见</div>
            </div>
            <div
              contenteditable="true"
              style="
                flex: 1;
                padding: 20px;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
              "
            >
              <div
                v-for="(item, index) in formData.unLeaders"
                :key="index"
                style="
                  margin-right: 16px;
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                "
              >
                <div v-if="item.approveUserNameSignUrl">
                  <img
                    :src="item.approveUserNameSignUrl"
                    width="100px"
                    height="38px"
                  />
                </div>
                <div v-else>
                  {{ item.approveUserName }}
                </div>
              </div>
            </div>
          </div>

          <div
            style="
              border-bottom: 1px solid rgb(0, 0, 0, 0.6);
              display: flex;
              min-height: 80px;
              page-break-inside:avoid;
            "
          >
            <div
              style="
                width: 120px;
                border-right: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                text-align: center;
              "
            >
              集团分管
              <div>领导意见</div>
            </div>
            <div
              contenteditable="true"
              style="flex: 1; padding: 20px; display: flex; align-items: center"
            >
              <div
                v-for="(item, index) in formData.leaders"
                :key="index"
                style="
                  margin-right: 16px;
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                "
              >
                <div v-if="item.approveUserNameSignUrl">
                  <img
                    :src="item.approveUserNameSignUrl"
                    width="100px"
                    height="38px"
                  />
                </div>
                <div v-else>
                  {{ item.approveUserName || "" }}
                </div>
              </div>
            </div>
          </div>

          <!-- <div
            style="
              border-bottom: 1px solid rgb(0, 0, 0, 0.6);
              display: flex;
              min-height: 56px;
            "
            v-for="(item, index) in formData.filterApproveInfoList"
            :key="index"
          >
            <div
              style="
                width: 120px;
                border-right: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              {{ item.deptKeyName }}
            </div>
            <div
              contenteditable="true"
              style="flex: 1; padding: 4px; display: flex; align-items: center"
            >
              {{ item.opinion }}
            </div>
            <div
              v-if="item.approveUserNameSignUrl"
              style="display: flex; align-items: flex-end; padding: 2px 4px 0 0"
            >
              <img
                :src="item.approveUserNameSignUrl"
                width="100px"
                height="38px"
              />
            </div>
            <div
              v-else
              style="display: flex; align-items: flex-end; padding: 0 4px 4px 0"
            >
              {{ item.approveUserName }}
            </div>
          </div> -->

          <div style="display: flex; min-height: 56px">
            <div
              style="
                width: 120px;
                border-right: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              联系人
            </div>
            <div
              contenteditable="true"
              style="flex: 1; padding: 4px; display: flex; align-items: center"
            >
              {{ formData.contactUserName }}
            </div>

            <div
              style="
                width: 120px;
                border-right: 1px solid rgb(0, 0, 0, 0.6);
                border-left: 1px solid rgb(0, 0, 0, 0.6);
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              联系电话
            </div>
            <div
              contenteditable="true"
              style="flex: 1; padding: 4px; display: flex; align-items: center"
            >
              {{ formData.contactUserPhone }}
            </div>
          </div>
        </div>
        <div height="20px">&nbsp;</div>
      </div>
      <div class="printWrap" v-show="false">
        <div
          v-html="ApproveAndSignPrintContent"
          class="mainHtml"
          id="printApproveAndSignPrintContent"
        ></div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import printJS from "print-js";

export default {
  name: "ApproveAndSignPrint",
  props: {
    printData: {
      type: Object,
    },
    visible: {
      type: Boolean,
      defaule: false,
    },
  },
  data() {
    return {
      approveProcessList: [],
      ApproveAndSignPrintContent: null,
    };
  },
  computed: {
    formData() {
      const filterApproveInfoList = this.printData.approveInfoList.filter(
        (i) => i.isPrint
      );
      const filterApproveInfoList1 = this.printData.approveInfoList.filter(
        (i) => i.isPrint&&!i.isLeaderOpinion
      );
       const leaders1= filterApproveInfoList.filter(
        (i) => i.isLeaderOpinion
      );
      const unLeaders1= filterApproveInfoList.filter(
        (i) => !i.isLeaderOpinion&&leaders1.every(e=>e.approveUserId!=i.approveUserId)
      );
      const map=new Map();
      const unLeaders= unLeaders1.filter(v=>!map.has(v.approveUserId)&&map.set(v.approveUserId,1))
     
      const map1=new Map();
      const leaders= leaders1.filter(v=>!map1.has(v.approveUserId)&&map1.set(v.approveUserId,1))
      let depts = filterApproveInfoList1.map((item) => {
        return item.deptKeyName;
      });
      let deptNames = Array.from(new Set(depts)).join(" 、 ");
      return {
        ...this.printData,
        deptNames,
        unLeaders,
        leaders,
      };
    },
  },

  mounted() {
    try{
this.ApproveAndSignPrintContent = this.$refs.MeetingOrderPrint.innerHTML;
    this.ApproveAndSignPrintContent =
      document.getElementById("MeetingOrderPrint").innerHTML;
    }catch(err){
      console.log(err)
    }
    
  },
  methods: {
    hideDialog() {
      this.$emit("update:visible", false);
    },
    //打印当前合同
    PrintContract() {
      this.$set(
        this,
        "ApproveAndSignPrintContent",
        this.$refs.MeetingOrderPrint.innerHTML
      );
      this.$nextTick(() => {
        printJS({
          printable: "printApproveAndSignPrintContent",
          type: "html",
          targetStyles: ["*"],
          ignoreElements: ["no-print", "bc", "gb"],
          scanStyles: false,
        });
      });
    },
  },
};
</script>
<style lang="scss">
#MeetingOrderPrint {
  box-shadow: 0px 4px 12px 2px #bbb;
  position: relative;
  padding: 0 10px;
  width: 21cm;
  margin: 0 auto;
}

.printWrap {
  width: 21cm;
  margin: 30px auto;
  padding: 5mm;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
}

.mainHtml {
  width: 21cm;
}
</style>
